module.exports = __webpack_public_path__ + "ca30b21952ac00f182cd1cba275d4308.png";